var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.progress)?_c('div',{staticClass:"o-progress"},[_c('div',{staticClass:"o-progress__indicator",style:({ transform: `scaleX(${_vm.progress})` })})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }